import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import translationPropType from '../../../proptypes/translationPropType';

const styles = theme => ({
    button: {
        marginRight: theme.spacing(1),
    },
    leftIcon: {
        marginRight: theme.spacing(1),
    },
});

const PrintButton = ({ classes, translation }) => (
    <Button
        variant="contained"
        color="primary"
        onClick={window.print}
        className={classes.button}
    >
        <PrintIcon className={classes.leftIcon} />
        {translation.PRINT}
    </Button>
);

PrintButton.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    translation: translationPropType.isRequired,
};

export default withStyles(styles)(PrintButton);
